var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFullIconLargeInactive = function SvgFullIconLargeInactive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "full-icon-large-inactive",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 56.25,
    viewBox: "0 0 100 56.25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "White_Box",
    "data-name": "White Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M685.032,535.343h-99v-55.25h99Z",
    transform: "translate(-585.532 -479.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M586.532,480.592v54.25h98v-54.25h-98m-1-1h100v56.25h-100Z",
    transform: "translate(-585.532 -479.592)",
    fill: "#ccd3da"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box",
    "data-name": "Grey Box",
    d: "M588.532,482.592h94.043v50.188H588.532Z",
    transform: "translate(-585.532 -479.592)",
    fill: "#ccd3da"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFullIconLargeInactive);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iZnVsbC1pY29uLWxhcmdlLWluYWN0aXZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iNTYuMjUiIHZpZXdCb3g9IjAgMCAxMDAgNTYuMjUiPgogIDxnIGlkPSJXaGl0ZV9Cb3giIGRhdGEtbmFtZT0iV2hpdGUgQm94Ij4KICAgIDxwYXRoIGlkPSJQYXRoXzEiIGRhdGEtbmFtZT0iUGF0aCAxIiBkPSJNNjg1LjAzMiw1MzUuMzQzaC05OXYtNTUuMjVoOTlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTg1LjUzMiAtNDc5LjU5MikiIGZpbGw9IiNmZmYiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzIiIGRhdGEtbmFtZT0iUGF0aCAyIiBkPSJNNTg2LjUzMiw0ODAuNTkydjU0LjI1aDk4di01NC4yNWgtOThtLTEtMWgxMDB2NTYuMjVoLTEwMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01ODUuNTMyIC00NzkuNTkyKSIgZmlsbD0iI2NjZDNkYSIvPgogIDwvZz4KICA8cGF0aCBpZD0iR3JleV9Cb3giIGRhdGEtbmFtZT0iR3JleSBCb3giIGQ9Ik01ODguNTMyLDQ4Mi41OTJoOTQuMDQzdjUwLjE4OEg1ODguNTMyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU4NS41MzIgLTQ3OS41OTIpIiBmaWxsPSIjY2NkM2RhIi8+Cjwvc3ZnPgo=";